import $ from 'jquery';

const childNavInit = () => {
    $('.c-child-navigation select').on('change', e => {
        e.preventDefault();
        window.location.href = e.target.value;
    });
};

$(() => {
    childNavInit();
});



// WEBPACK FOOTER //
// ./src/components/child-navigation/c-child-navigation.js